module.exports = __webpack_public_path__ + "assets/img/twitter_new.1b646042.png";